import React, {useEffect, useState} from 'react';
import RegistrySearchHeader from './pageHeader/PageHeader';
import TableAdministration from '../../../components/tablesAdministration/Table-administration';
import {Deactivate} from '../../../components/modals/ModalUserDeactivate';
import {Show} from '../../../components/modals/ModalShow';
import {Edit} from '../../../components/modals/ModalEdit';
import {Add} from '../../../components/modals/ModalAdd';
import * as AXIOS from '../../../services/usersService';
import Swal from 'sweetalert2';
import {t, getLanguage} from 'react-switch-lang';
import './Users.scss';
import Loader from '../../../components/loader/Loader';
import {searchUsersTable} from './searchUsersTable';

const PAGE_SIZE = 20;

const Users = () => {
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState('');
  const [rowChanged, setRowChanged] = useState(false);
  const [search, setSearch] = useState('');
  const [tableKey, setTableKey] = useState(0);

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const getAuthority = (param, authorityArray) => {
    const result = [];
    if (Array.isArray(authorityArray)) {
      authorityArray.forEach((item) => {
        result.push(item[param]);
      });
    }
    return result.length > 0 ? result.join(', ') : '';
  };

  const onRowClick = (item) => {
    setModalData(item);
    setModal((prev) => !prev);
  };

  const onRowChange = () => {
    setSearch('');
    setItems([]);
    setFilterItems([]);
    setPage(0);
    setHasMore(true);
    setRowChanged((prev) => !prev);
    setTableKey((prev) => prev + 1);
  };

  const generateRows = (users) => {
    return users.map((item) => {
      const lang =
        item.langKey === 'mne' ? t('language.mneLat') : t('language.english');

      return {
        // id: item.id,
        username: item.login,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        authority:
          getLanguage() === 'eng'
            ? getAuthority('name', item.authority)
            : getAuthority('description', item.authority),
        activated: item.activated,
        langKey: lang,
        onClick: () => onRowClick(item),
        buttons: [
          <Edit
            key={`edit-${item.id}`}
            data={item}
            id="user"
            setRowChanged={() => onRowChange()}
          />,
          <Deactivate
            key={`deactivate-${item.id}`}
            data={item}
            id="user"
            setRowChanged={() => onRowChange()}
          />,
        ],
      };
    });
  };

  const fetchData = async (requestedPage = 0, reset = false) => {
    if (isLoading) return;

    setIsLoading(true);
    if (requestedPage === 0) {
      setIsLoadingPage(true);
    }

    try {
      const r = await AXIOS.getAllUsers(requestedPage, PAGE_SIZE, search);
      const data = Array.isArray(r.data) ? r.data : [];
      const newRows = generateRows(data);

      if (reset || requestedPage === 0) {
        setItems(newRows);
        setFilterItems(newRows);
      } else {
        setItems((prev) => [...prev, ...newRows]);
        setFilterItems((prev) => [...prev, ...newRows]);
      }

      setHasMore(data.length === PAGE_SIZE);
      setPage(requestedPage);
    } catch (r) {
      if (r.message === 'Network Error') {
        Swal.fire({
          text: `${t('message.errorServerTitle')}`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          text: `${t('message.errorApi')}`,
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    } finally {
      setIsLoading(false);
      setIsLoadingPage(false);
    }
  };

  const fetchMoreData = () => {
    if (isLoading || search || !hasMore) return;
    fetchData(page + 1, false);
  };

  useEffect(() => {
    fetchData(0, true);
  }, [rowChanged, search]);

  const tableHeader = [
    t('users.label.username'),
    t('users.label.firstname'),
    t('users.label.lastname'),
    t('users.label.email'),
    t('users.label.authorities'),
    t('users.label.langKey'),
  ];

  return (
    <div style={{padding: '0 30px'}} className="h-100 pb-3">
      <Show
        data={modalData}
        id="user"
        type="user"
        modal={modal}
        setModal={setModal}
        isEditable={true}
        setRowChanged={() => onRowChange()}
      />

      <RegistrySearchHeader
        placeholder={t('users.searchInput')}
        button={<Add id="user" setRowChanged={() => onRowChange()} />}
        onChange={(e) => setSearch(e.target.value)}
        searchValue={search}
        showInput={true}
        showButton={true}
      />

      <div className="position-relative administration-page-table-container pt-4">
        {isLoadingPage && <Loader />}

        <TableAdministration
          key={tableKey}
          tableHeader={tableHeader}
          tableRows={search ? filterItems : items}
          fetchMoreData={fetchMoreData}
          hasMore={!search && hasMore}
          editableRow={false}
        />
      </div>
    </div>
  );
};

export default Users;